/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import { Card, Typography } from '@mui/material';
import MuiGrid from '@mui/material/Grid';
import { PropTypes } from 'prop-types';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CreateEmailTemplate, TemplateList } from '../../components/campaign';

const Grid = (props) => (
  <MuiGrid
    item
    xs={4}
    {...props}
    sx={
      props.selected
        ? { borderBottom: '4px solid #FF2C04', cursor: 'pointer', p: 2 }
        : { borderBottom: '4px solid transparent', cursor: 'pointer', p: 2 }
    }
  />
);

Grid.propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default function EmailTemplates() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState('purchased');
  const { action } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setSelected(action);
  }, [action]);

  const handleTabChange = (tab) => {
    navigate(`/dashboard/campaigns/email-templates/${tab}`);
  };

  return (
    <div>
      <Card sx={{ textAlign: 'center' }}>
        <MuiGrid container>
          <Grid onClick={() => handleTabChange('purchased')} selected={selected === 'purchased'}>
            <Typography variant="h5">Purchased</Typography>
          </Grid>
          <Grid onClick={() => handleTabChange('new')} selected={selected === 'new'}>
            <Typography variant="h5">New</Typography>
          </Grid>
          <Grid onClick={() => handleTabChange('custom')} selected={selected === 'custom'}>
            <Typography variant="h5">Custom</Typography>
          </Grid>
        </MuiGrid>
      </Card>
      {selected === 'custom' ? (
        <CreateEmailTemplate templateName={searchParams.get('name')} />
      ) : selected === 'new' ? (
        <TemplateList />
      ) : (
        <Card sx={{ p: 2, mt: 2 }}>No templates here yet</Card>
      )}
    </div>
  );
}
